export default __webpack_public_path__ + "static/media/navbar-icon-promotions.1e531338.svg";